import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/constants/content";

export const FaqSection = () => (
  <section className="py-12" aria-labelledby="faq-title" data-testid="faq-section">
    <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-amber-300">FAQ</p>
    <h2 id="faq-title" className="mt-2 text-base font-bold text-white md:text-lg">Questions founders ask before validating</h2>
    <Accordion type="single" collapsible className="iv-glass mt-6 rounded-2xl px-4 sm:px-6">
      {FAQS.map((f, i) => (
        <AccordionItem key={f.q} value={`faq-${i}`} className="border-white/[0.06]">
          <AccordionTrigger className="text-left text-sm font-semibold text-white hover:no-underline" data-testid={`faq-trigger-${i}`}>{f.q}</AccordionTrigger>
          <AccordionContent className="text-sm leading-relaxed text-slate-400">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
